import { AccomodationTranslationDto } from "./accomodation-translation.dto";
import { LocationDto } from "./location.dto";
export class AccomodationTranslationLocationDto{
    location?:LocationDto;
    accomodationTranslationDto?: AccomodationTranslationDto;
    
    constructor(
        location?: LocationDto,
        accomodationTranslationDto?: AccomodationTranslationDto
    ){
        this.location = location;
        this.accomodationTranslationDto = accomodationTranslationDto;
    }
}